module.exports = __webpack_public_path__ + "assets/505-bg.3cfbf703.webp";